import styled from 'styled-components';

export const FixedWidthDiv = styled.div`
    min-width: 48px !important;
`;
